import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { AdminUserInfo } from 'src/app/store/actions/adminuser.action';
import { AppState } from 'src/app/store/app.states';
import { NavigationEnd,Event, NavigationError, NavigationStart, Router } from '@angular/router';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';

declare var $: any;
declare var DataTable:any;

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdminComponent implements OnInit {
  url: string;

  
  constructor(private store: Store<AppState>,private router: Router,private adminApi: AdminapiService) {
    
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
          // Show progress spinner or progress bar
          //console.log('Route change detected');
      }

      if (event instanceof NavigationEnd) {
          // Hide progress spinner or progress bar
          console.log(event.url)
          this.url = event.url;        
      }

      if (event instanceof NavigationError) {
           // Hide progress spinner or progress bar

          // Present error to user
          //console.log(event.error);
      }
  });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.adminApi.setLoader(false)
    }, 3000);
  }

  ngOnInit(): void {
    this.store.dispatch(new AdminUserInfo())
    $(document).on('click',"[data-bs-toggle=minimize]",function(){
        if (($('body').hasClass('sidebar-toggle-display')) || ($('body').hasClass('sidebar-absolute'))) {
          $('body').toggleClass('sidebar-hidden');
        } else {
          $('body').toggleClass('sidebar-icon-only');
        }
    });
    DataTable.pipeline = function (opts) {
        // Configuration options
        var conf = Object.assign(
            {
                pages: 5, // number of pages to cache
                url: '', // script url
                data: null, // function or object with parameters to send to the server
                // matching how `ajax.data` works in DataTables
                method: 'GET' // Ajax HTTP method
            },
            opts
        );
    
        // Private variables for storing the cache
        var cacheLower = -1;
        var cacheUpper = null;
        var cacheLastRequest = null;
        var cacheLastJson = null;
    
        return async function (request, drawCallback, settings) {
            var ajax = false;
            var requestStart = request.start;
            var drawStart = request.start;
            var requestLength = request.length;
            var requestEnd = requestStart + requestLength;
    
            if (settings.clearCache) {
                // API requested that the cache be cleared
                ajax = true;
                settings.clearCache = false;
            }
            else if (
                cacheLower < 0 ||
                requestStart < cacheLower ||
                requestEnd > cacheUpper
            ) {
                // outside cached data - need to make a request
                ajax = true;
            }
            else if (
                JSON.stringify(request.order) !==
                    JSON.stringify(cacheLastRequest.order) ||
                JSON.stringify(request.columns) !==
                    JSON.stringify(cacheLastRequest.columns) ||
                JSON.stringify(request.search) !==
                    JSON.stringify(cacheLastRequest.search)
            ) {
                // properties changed (ordering, columns, searching)
                ajax = true;
            }
    
            // Store the request for checking next time around
            cacheLastRequest = JSON.parse(JSON.stringify(request));
    
            if (ajax) {
                // Need data from the server
                if (requestStart < cacheLower) {
                    requestStart = requestStart - requestLength * (conf.pages - 1);
    
                    if (requestStart < 0) {
                        requestStart = 0;
                    }
                }
    
                cacheLower = requestStart;
                cacheUpper = requestStart + requestLength * conf.pages;
    
                request.start = requestStart;
                request.length = requestLength * conf.pages;
    
                // Provide the same `data` options as DataTables.
                if (typeof conf.data === 'function') {
                    // As a function it is executed with the data object as an arg
                    // for manipulation. If an object is returned, it is used as the
                    // data object to submit
                    var d = conf.data(request);
                    if (d) {
                        Object.assign(request, d);
                    }
                }
                else if (conf.data) {
                    // As an object, the data given extends the default
                    Object.assign(request, conf.data);
                }
    
                // Use `fetch` to make Ajax request
                let response = await fetch(
                    conf.url + '?json=' + JSON.stringify(request),
                    {
                        method: conf.method
                    }
                );
    
                let json = await response.json();
    
                cacheLastJson = JSON.parse(JSON.stringify(json));
    
                if (cacheLower != drawStart) {
                    json.data.splice(0, drawStart - cacheLower);
                }
                if (requestLength >= -1) {
                    json.data.splice(requestLength, json.data.length);
                }
                drawCallback(json);
            }
            else {
              let json:any;
                json = JSON.parse(JSON.stringify(cacheLastJson));
                json.draw = request.draw; // Update the echo for each response
                json.data.splice(0, requestStart - cacheLower);
                json.data.splice(requestLength, json.data.length);
    
                drawCallback(json);
            }
        };
    };
    
    // Register an API method that will empty the pipelined data, forcing an Ajax
    // fetch on the next draw (i.e. `table.clearPipeline().draw()`)
    DataTable.Api.register('clearPipeline()', function () {
        return this.iterator('table', function (settings) {
            settings.clearCache = true;
        });
    });
    
    // this.store.dispatch(new UserInfo())
    
  }

}
